import service from '@/api/service/service';
import qs from "qs";

// 心跳
export function heartBeat(params = {}) {
  return service({
    url: "/api/main/heartbeat.json",
    method: 'get',
    params: params,
  });
}
// 退出登录
export function signOut(params = {}, token, userType) {
  return service({
    url: "/api/main/logout.json",
    method: 'get',
    headers: {"X-Token": token, "X-UserType": userType},
    params: params,
  });
}

// 上传图片
export function upImage(data = {}, progress = (event) => {}) {
  return service({
    url: '/api/index/up_img.json',
    method: 'post',
    data, // 注意💊：这里的上传参数是file类型，不能用qs处理
    onUploadProgress: progress,
  })
}

// 上传精彩瞬间，即批量上传
export function batchUpImage(data = {}) {
  return service({
    url: '/api/organization/moment_uploading.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

/* 获取盐 */
export function getPwdSalt(data = {}) {
  return service({
    url: "/api/user/get_password_salt.json",
    method: "post",
    data: qs.stringify(data)
  })
}

/* system_manager系统管理员->讲师&&学员 培训历程->培训班列表 */
/* training_teacher培训班讲师 */
export function userClassList(data = {}) {
  return service({
    url: "/api/user/user_class_list.json",
    method: 'post',
    data: qs.stringify(data),
  });
}
/* 培训班详情 */
export function classDetailInfo(params = {}) {
  return service({
    url: "/api/organization/class_train_info.json",
    method: 'get',
    params: params,
  });
}
export function classDetailList(params = {}) {
  return service({
    url: "/api/organization/class_group_student.json",
    method: 'get',
    params: params,
  });
}


// 精彩瞬间公共接口
export function getMomentList(params = {}) {
  return service({
    url: '/api/organization/moment_list.json',
    method: 'get',
    params: params
  })
}

// 精彩瞬间图片设为封面
export function setMomentCover(data = {}) {
  return service({
    url: '/api/organization/moment_cover.json',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除精彩瞬间中的图片
export function delMoment(data = {}) {
  return service({
    url: '/api/organization/moment_delete.json',
    method: 'post',
    data: qs.stringify(data)
  })
}

/* 下载学员帐号 */
export function getStuAccount(params = {}) {
  return service({
    url: '/api/organization/student_download.json',
    method: 'get',
    params: params
  })
}

/* 学员教案列表 用post搜索 */
export function stuTutorialList(data = {}) {
  return service({
    url: "/api/plan/student_plan_list.json",
    method: 'post',
    data: qs.stringify(data)
  });
}


/* 学员教案列表 用post搜索  只有系统管理员用*/
export function plan_list(data = {}) {
  return service({
    url: "/api/plan/plan_list.json",
    method: 'post',
    data: qs.stringify(data)
  });
}

/* 机构详情 */
export function orgDetailInfo(params = {}) {
  return service({
    url: "/api/organization/organization_info.json",
    method: 'get',
    params: params,
  });
}

/* 机构管理员&&讲师测评数量 */
export function evaluationNum(params = {}) {
  return service({
    url: "/api/evaluation/no_evaluation_num.json",
    method: 'get',
    params: params,
  });
}

/* 机构管理员&&讲师测评数量 */
export function scoreDetail(params = {}) {
  return service({
    url: "/api/organization/score_view_info.json",
    method: 'get',
    params: params,
  });
}

/* 下载成绩 */
export function scoreDownload(params = {}) {
  return service({
    url: "/api/organization/class_score_download.json",
    method: 'get',
    params: params,
  });
}

// 获取培训班的分组数据列表
export function getGroupingList(params = {}) {
  return service({
    url: '/api/organization/group_student_back.json',
    method: 'get',
    params
  })
}

// 调整培训班小组顺序
export function groupingStusAjax(data = {}) {
  return service({
    url: '/api/organization/group_student_ajax.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 学员详细信息
export function getStuDetailInfo(params = {}) {
  return service({
    url: "/api/main/stu_singn_info_view.json",
    method: 'get',
    params,
  });
}

// 待确认学员文件下载
export function unConfirmStus(params = {}) {
  return service({
    url: '/api/organization/unusual_stu_export.json',
    method: 'get',
    params
  })
}

// 保存操作信息 公用接口
export function operationMsgSave(data = {}) {
  return service({
    url: '/api/main/operation_msg_save.json',
    method: 'post',
    data: qs.stringify(data)
  })
}


// 培训班下讲师晋升经历
export function promoteClassTeacher(data = {}) {
  return service({
    url: '/api/organization/promote_class_teacher.json',
    method: 'post',
    data: qs.stringify(data)
  })
}


// 学员执照领取列表
export function user_license_list(params = {}) {
  return service({
    url: '/api/license/user_license_list.json',
    method: 'get',
    params
  })
}


// 学员执照领取，填写地址
export function license_get_way_save(data = {}) {
  return service({
    url: '/api/license/license_get_way_save.json',
    method: 'post',
    data: qs.stringify(data)
  })
}



// 学员执照领取，填写地址
export function license_get_way_info(params = {}) {
  return service({
    url: '/api/license/license_get_way_info.json',
    method: 'get',
    params
  })
}


export function plan_make_tag(data = {}) {
  return service({
    url: '/api/plan/plan_make_tag.json',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function user_audit_list(params) {
  return service({
    url: '/api/organization/user_audit_list.json',
    method: 'get',
    params
  })
}

// demo
export function qualification(data = {}) {
  return service({
    url: '/api/index/dishonest_people_appeal_submit.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 暂停培训班
export function pauseClass(data = {}) {
  return service({
    url: '/api/organization/pause_class.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 查看个人积分明细 返回的得分项
export function stuScoreList(params) {
  return service({
    url: '/api/main/stuScoreList.json',
    method: 'get',
    params
  })
}
/* 查看助理讲师填写的报告 */
export function reportAssistant(params = {}) {
  return service({
    url: "/api/organization/class_report_info_assistant.json",
    method: 'get',
    params: params,
  });
}
// 提交投诉
export function feedbackAdd(data = {}) {
  return service({
    url: '/api/feedback/feedback_add.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 提交情况/事件反馈
export function feedbackOtherAdd(data = {}) {
  return service({
    url: '/api/feedback/feedback_other_add.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 是否可以提交投诉
export function feedbackShow(params) {
  return service({
    url: '/api/feedback/feedback_show.json',
    method: 'get',
    params
  })
}
/* 培训班详情 */
export function feedbackClassTrain(params = {}) {
  return service({
    url: "/api/feedback/feedback_class_train.json",
    method: 'get',
    params: params,
  });
}
// 讲师简历下载
export function getTeacherResumeDown(params = {}) {
  return service({
    url: '/api/user/teacher_resume_down.json',
    method: 'get',
    params
  })
}

// 白底图校验
export function checkPicture(data = {}) {
  return service({
    url: "/api/main/checkPicture.json",
    method: 'post',
    data: qs.stringify(data),
  });
}
